import React, { useEffect, useState } from 'react';
import LoadingComp from '../../../../components/LoadingComp';
import { useNavigate, useLocation } from 'react-router-dom';
import { getTourPackageById } from '../../../../../redux/api/tourPackages.api';
import { Modal, notification, Steps } from 'antd';
import DateAndQuentity from './DateAndQuentity';

import './styles.scss';
import { TAX_RATE, TOUR_PACKAGE_PAYMENT } from '../../../../constants/finance';
import OtherServices from './OtherServices';
import TravelerDetils from './TravelerDetils';
import { useMsal } from '@azure/msal-react';
import { LOGIN_REQUEST } from '../../../../azure/authConfig';
import TourBookingConfirmation from './TourBookingConfirmation';
import TourBookingPayment from './TourBookingPayment';
import usePageSettings from '../../../../hooks/usePageSettings';
import useCurrencyRates from '../../../../hooks/useCurrencyRates';
import { convertCurrency } from '../../../../helpers/currencyConverter';
import { addPayment, editUserTourCustomer } from '../../../../../redux/api/userTour.api';
import { checkewayPayment } from '../../../../../redux/api/payment.api';
import moment from 'moment';
import { CloseCircleFilled, InfoCircleFilled } from '@ant-design/icons';

const BookTourPackage = () => {
    const url = window.location.pathname;
    const tourPackageId = url.split('/')[2];
    const [loading, setLoading] = useState(true);
    const [api, contextHolderNoti] = notification.useNotification();
    const [tourPackage, setTourPackage] = useState(null);
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const location = useLocation();
    const navigate = useNavigate();
    const [paymentError, setPaymentError] = useState({
        type: null,
        title: null,
        message: null,
    });

    const [userTourData, setUserTourData] = useState({});
    const currencyRates = useCurrencyRates()?.currencyRates
    const selectedCurrency = usePageSettings()?.selectedCurrency;

    const [current, setCurrent] = useState(0);
    const next = () => setCurrent(current + 1);
    const prev = () => setCurrent(current - 1);

    const [processingPayment, setProcessingPayment] = useState(false);

    useEffect(() => {
        if (!activeAccount) {
            handleLoginRedirect();
        }
    }, []);

    useEffect(() => {
        if (!tourPackageId) {
            navigate('/tours');
        }
        handleGetTourPackage(tourPackageId);

        setUserTourData({
            startDate: '',
            adults: 1,
            children: 0,
            infants: 0,
            roomType: 'Single',
            vehicleType: 'Hatchback',
            tax: 0,
            finalPayment: 0,
            selectedVehicalPrice: 0,
            userData: {},
            paymentOption: null,
            instalmentPlan: null,
            termsAndConditions: false,
            filghtDetails: {
                flightBooked: false,
                flightNumber: '',
                arrivalDateTime: '',
                departureAirport: ''
            },
        });
    }, [tourPackageId, navigate]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const accessCode = urlParams.get('AccessCode');
        const tourId = urlParams.get('tourId');
        const userId = urlParams.get('userId');
        const amount = urlParams.get('amount');
        const currency = urlParams.get('currency');
        if (accessCode && tourId && userId && amount && currency) {
            setProcessingPayment(true);

            const beforeUnload = (e) => {
                e.preventDefault();
                e.returnValue = 'Payment is processing. Please do not close or navigate away.';
            };
            window.addEventListener('beforeunload', beforeUnload);
            const blockNav = (e) => {
                e.preventDefault();
                return false;
            };
            window.history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', blockNav);

            (async () => {
                try {
                    const paymentCheckRes = await checkewayPayment(accessCode);
                    
                    let paymentStatus = 'FAILED';
                    let shouldUpdateTour = false;
                    
                    if (paymentCheckRes?.data?.success && paymentCheckRes?.data?.transactionStatus) {
                        paymentStatus = 'COMPLETED';
                        shouldUpdateTour = true;
                    }

                    const paymentData = {
                        userId,
                        paidFor: tourId,
                        paymentType: TOUR_PACKAGE_PAYMENT,
                        paymentMethod: 'CARD',
                        paymentStatus,
                        paymentAmount: amount,
                        paymentCurrency: currency,
                        paymentDate: moment().format('MMM D YYYY h:mma'),
                        paymentTime: moment().format('h:mma'),
                        paymentReference: `Booking ID (${tourId})`,
                        paymentGateway: 'EWAY',
                        paymentGatewayId: accessCode,
                        paymentGatewayResponse: JSON.stringify(paymentCheckRes?.data || {}),
                        paymentGatewayStatus: paymentStatus === 'COMPLETED' ? 'SUCCESS' : 'FAILED',
                        paymentGatewayReference: paymentCheckRes?.data?.transactionId?.toString() || accessCode,
                        paymentGatewayAmount: amount,
                        paymentGatewayCurrency: currency,
                        paymentGatewayDate: moment().format('MMM D YYYY h:mma'),
                        paymentGatewayTime: moment().format('h:mma'),
                        paymentGatewayDescription: `Payment for tour booking ${tourId}`,
                    };

                    const paymentRes = await addPayment(paymentData);
                    
                    if (shouldUpdateTour) {
                        if (paymentRes.status === 201 || paymentRes.status === 200) {
                            const updateRes = await editUserTourCustomer({
                                id: tourId,
                                paymentStatus: 'PAID',
                                bookingStatus: 'CONFIRMED',
                                paymentId: paymentRes?.data?.id,
                                paidAt: moment().format('MMM D YYYY h:mma'),
                                instalmentPayments: null
                            });
                            
                            if (updateRes.status === 200) {
                                api.open({ 
                                    type: 'success', 
                                    message: 'Payment Successful', 
                                    description: 'Your payment and booking have been confirmed successfully.' 
                                });
                                setTimeout(() => {
                                    navigate('/dashboard/my-bookings/tours');
                                }, 2000);
                            } else {
                                setPaymentError({
                                    type: 'error',
                                    title: 'Error Updating Booking',
                                    message: `Payment was successful, but booking update failed. Please contact support.`
                                })
                            }
                        } else {
                            setPaymentError({
                                type: 'error',
                                title: 'Payment Recording Failed',
                                message: `Payment was successful, but booking update failed. Please contact support.`
                            })
                        }
                    } else {
                        setPaymentError({
                            type: 'error',
                            title: 'Payment Failed',
                            message: 'Payment was unsuccessful. Please try again or contact support.'
                        })
                    }
                } catch (error) {
                    setPaymentError({
                        type: 'error',
                        title: 'Payment Processing Error',
                        message: 'An error occurred while processing your payment. Please contact support.'
                    })
                }
                
                window.removeEventListener('beforeunload', beforeUnload);
                window.removeEventListener('popstate', blockNav);
                setProcessingPayment(false);
                window.history.replaceState({}, document.title, window.location.pathname); 
            })();
        }
        // eslint-disable-next-line
    }, [location.search]);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = 'Payment is processing. Are you sure you want to leave? This may result in payment or booking not being completed.';
            return e.returnValue;
        };
        
        if (processingPayment) {
            window.addEventListener('beforeunload', handler);

            return () => {
              window.removeEventListener('beforeunload', handler);
            };
        } else {
            window.removeEventListener('beforeunload', handler);
        }
    }, [processingPayment]);

    const handleLoginRedirect = () => {
        instance.handleRedirectPromise()
            .then((response) => {
                if (response) {
                    instance.setActiveAccount(response.account);
                } else {
                    instance.loginRedirect(LOGIN_REQUEST)
                        .catch((e) => {
                            console.error('User Login Error', e);
                        });
                }
            })
            .catch((error) => {
                console.error('Redirect Handling Error', error);
            });
    }

    const handleGetTourPackage = async (id) => {
        setLoading(true);
        try {
            const tour = await getTourPackageById(id);
            setTourPackage(tour.data[0]);
        } catch (error) {
            console.error('Error fetching destination', error);
        }
        setLoading(false);
    };

    const getVehiclePrice = (type) => {
        switch (type) {
            case 'Hatchback':
                return tourPackage?.vehicleHatchback;
            case 'Sedan':
                return tourPackage?.vehicleSedan;
            case 'Suv':
                return tourPackage?.vehicleSuv;
            case 'Van':
                return tourPackage?.vehicleVan;
            case 'Coster':
                return tourPackage?.VehicleCoster;
            default:
                return 0;
        }
    }

    const getTransportationPrice = (vehiclePrice, members) => {
        // if (members > 6) {
        //     return vehiclePrice * 2;
        // }
        return vehiclePrice;
    }

    const getGuidePrice = (guidePrice, members) => {
        if (members > 10) {
            return guidePrice * 2;
        }
        return guidePrice;
    }

    const getRoomPrice = (roomType, members) => {
        if (!roomType || !members || members < 1) return 0

        const roomBasePrice = tourPackage?.[`room${roomType}`] || 0
        const maxCapacity = {
            Single: 1,
            Double: 2,
            Triple: 3,
            Family: 4
        }

        const roomCapacity = maxCapacity[roomType] || 1
        const roomsNeeded = Math.ceil(members / roomCapacity)

        return roomBasePrice * roomsNeeded
    }

    const calculateTotal = () => {
        const packagePrice = tourPackage?.pricePackage;
        const guidePrice = tourPackage?.priceGuide;
        const selectedVehicalPrice = getVehiclePrice(userTourData?.vehicleType);
        const totalMembers = userTourData?.adults + userTourData?.children + userTourData?.infants;

        const transportationPrice = getTransportationPrice(selectedVehicalPrice, totalMembers);
        const guideFinalPrice = getGuidePrice(guidePrice, totalMembers);
        const selectedRoomTypePrice = getRoomPrice(userTourData?.roomType, totalMembers);

        const packageFinalPrice = packagePrice * totalMembers;

        const total = packageFinalPrice + transportationPrice + guideFinalPrice + selectedRoomTypePrice;

        const discount = tourPackage?.discount ? total * (tourPackage?.discount / 100) : 0;

        const totalAfterDiscount = total - discount;
        const tax = totalAfterDiscount * TAX_RATE;
        let grandTotal = totalAfterDiscount + tax;
        grandTotal = Math.round((grandTotal + Number.EPSILON) * 100) / 100;

        grandTotal = grandTotal ? convertCurrency(grandTotal, selectedCurrency, currencyRates) : 0

        return grandTotal;
    }

    const calculateSubTotal = () => {
        const packagePrice = tourPackage?.pricePackage;
        const guidePrice = tourPackage?.priceGuide;
        const selectedVehicalPrice = getVehiclePrice(userTourData?.vehicleType);
        const totalMembers = userTourData?.adults + userTourData?.children + userTourData?.infants;

        // get transportation price
        const transportationPrice = getTransportationPrice(selectedVehicalPrice, totalMembers);

        // get guide price
        const guideFinalPrice = getGuidePrice(guidePrice, totalMembers);

        // get room price
        const selectedRoomTypePrice = getRoomPrice(userTourData?.roomType, totalMembers);

        // get package price
        const packageFinalPrice = packagePrice * totalMembers;

        let total = packageFinalPrice + transportationPrice + guideFinalPrice + selectedRoomTypePrice;
        total = Math.round((total + Number.EPSILON) * 100) / 100;
        total = total ? convertCurrency(total, selectedCurrency, currencyRates) : 0
        return total;
    }

    const calculateTax = () => {
        const packagePrice = tourPackage?.pricePackage;
        const guidePrice = tourPackage?.priceGuide;
        const selectedVehicalPrice = getVehiclePrice(userTourData?.vehicleType);
        const totalMembers = userTourData?.adults + userTourData?.children + userTourData?.infants;

        // get transportation price
        const transportationPrice = getTransportationPrice(selectedVehicalPrice, totalMembers);

        // get guide price
        const guideFinalPrice = getGuidePrice(guidePrice, totalMembers);

        // get room price
        const selectedRoomTypePrice = getRoomPrice(userTourData?.roomType, totalMembers);

        // get package price
        const packageFinalPrice = packagePrice * totalMembers;

        const total = packageFinalPrice + transportationPrice + guideFinalPrice + selectedRoomTypePrice;
        const discount = tourPackage?.discount ? total * (tourPackage?.discount / 100) : 0;

        const totalAfterDiscount = total - discount;
        let tax = totalAfterDiscount * TAX_RATE;
        tax = Math.round((tax + Number.EPSILON) * 100) / 100;
        tax = tax ? convertCurrency(tax, selectedCurrency, currencyRates) : 0
        return tax;
    }

    const calculateDiscount = () => {
        const packagePrice = tourPackage?.pricePackage;
        const guidePrice = tourPackage?.priceGuide;
        const selectedVehicalPrice = getVehiclePrice(userTourData?.vehicleType);
        const totalMembers = userTourData?.adults + userTourData?.children + userTourData?.infants;

        // get transportation price
        const transportationPrice = getTransportationPrice(selectedVehicalPrice, totalMembers);

        // get guide price
        const guideFinalPrice = getGuidePrice(guidePrice, totalMembers);

        // get room price
        const selectedRoomTypePrice = getRoomPrice(userTourData?.roomType, totalMembers);

        // get package price
        const packageFinalPrice = packagePrice * totalMembers;

        const total = packageFinalPrice + transportationPrice + guideFinalPrice + selectedRoomTypePrice;
        let discount = tourPackage?.discount ? total * (tourPackage?.discount / 100) : 0;
        discount = Math.round((discount + Number.EPSILON) * 100) / 100;
        discount = discount ? convertCurrency(discount, selectedCurrency, currencyRates) : 0
        return discount;
    }

    const steps = [
        {
            title: 'Date & Quantity',
            content: <DateAndQuentity
                tourPackage={tourPackage}
                userTourData={userTourData}
                setUserTourData={setUserTourData}
                messageApi={api}
                prev={prev}
                next={next}
                calculateTotal={calculateTotal}
                calculateSubTotal={calculateSubTotal}
                calculateTax={calculateTax}
                calculateDiscount={calculateDiscount}
                current={current}
            />,
        },
        {
            title: 'Other Services',
            content: <OtherServices
                tourPackage={tourPackage}
                userTourData={userTourData}
                setUserTourData={setUserTourData}
                messageApi={api}
                prev={prev}
                next={next}
                calculateTotal={calculateTotal}
                calculateSubTotal={calculateSubTotal}
                calculateTax={calculateTax}
                calculateDiscount={calculateDiscount}
                current={current}
            />,
        },
        {
            title: 'Traveler Information',
            content: <TravelerDetils
                tourPackage={tourPackage}
                userTourData={userTourData}
                setUserTourData={setUserTourData}
                messageApi={api}
                prev={prev}
                next={next}
                calculateTotal={calculateTotal}
                calculateSubTotal={calculateSubTotal}
                calculateTax={calculateTax}
                calculateDiscount={calculateDiscount}
                current={current}
            />,
        },
        {
            title: 'Confirmation',
            content: <TourBookingConfirmation
                tourPackage={tourPackage}
                userTourData={userTourData}
                setUserTourData={setUserTourData}
                messageApi={api}
                prev={prev}
                next={next}
                calculateTotal={calculateTotal}
                calculateSubTotal={calculateSubTotal}
                calculateTax={calculateTax}
                calculateDiscount={calculateDiscount}
                current={current}
            />,
        },
        {
            title: 'Payment',
            content: <TourBookingPayment
                tourPackage={tourPackage}
                userTourData={userTourData}
                setUserTourData={setUserTourData}
                messageApi={api}
                prev={prev}
                next={next}
                calculateTotal={calculateTotal}
                calculateSubTotal={calculateSubTotal}
                calculateTax={calculateTax}
                calculateDiscount={calculateDiscount}
                current={current}
            />,
        }
    ];

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    return (
        <>
            {processingPayment && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.95)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <LoadingComp />
                    <div style={{ marginTop: 24, fontSize: 20, color: '#333', fontWeight: 500 }}>
                        Processing your payment and booking. Please do not close or navigate away.
                    </div>
                </div>
            )}
            {!loading ? (
                <div className='main__contaier bookTour section_main'>
                    {contextHolderNoti}
                    <div className='hero top_margin_main'>
                        <Steps
                            current={current}
                            items={items}
                            progressDot={window.innerWidth > 768 ? false : true}
                        />
                        <div className='content_body_main'>
                            {steps[current].content}
                        </div>
                    </div>
                </div>
            ) : (
                <div className='loading_page'>
                    <LoadingComp />
                </div>
            )}

            <Modal
                open={paymentError.type}
                onCancel={() => {
                    setPaymentError({
                        type: null,
                        title: null,
                        message: null,
                    })
                    navigate('/dashboard/my-bookings/tours');
                }}
                footer={null}
                width={450}
                centered
                >
                <div className='payment_error'>
                    <div className='payment_error_title'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <div className='payment_error_title_icon'>
                            {
                                paymentError.type === 'error' ? (
                                    <CloseCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                ) : (
                                    <InfoCircleFilled style={{ color: 'red' , fontSize: 25, marginRight: 10 }} />
                                )
                            }
                        </div>
                        <div className='payment_error_title_text'>
                            <h3>{paymentError.title}</h3>
                        </div>
                    </div>

                    <p>{paymentError.message}</p>
                </div>
            </Modal>
        </>
    );
};

export default BookTourPackage;
